var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "utxo_col"
  }, [_c('div', {
    staticClass: "utxo_label"
  }, [_c('span', {
    staticClass: "index"
  }, [_vm._v("#" + _vm._s(_vm.index) + " ")]), _vm.utxo.outputType !== 7 ? _c('span', {
    staticClass: "type tag",
    style: {
      color: _vm.foreground
    }
  }, [_vm._v(_vm._s(_vm._f("getOutputType")(_vm.utxo.outputType)))]) : _vm._e(), _vm.isMint ? _c('span', {
    staticClass: "type tag minted",
    style: {
      color: _vm.foreground
    }
  }, [_vm._v("Minted")]) : _vm._e(), _vm.isPVMExport || _vm.isExport || _vm.isAtomicExport ? _c('span', {
    staticClass: "tag",
    style: {
      color: _vm.foreground
    }
  }, [_vm._v("Exported to Atomic Memory")]) : _vm._e(), _vm.isPVMImport || _vm.isImport || _vm.isAtomicImport ? _c('span', {
    staticClass: "tag",
    style: {
      color: _vm.foreground
    }
  }, [_vm._v("Imported from Atomic Memory")]) : _vm._e()]), _c('div', [_vm.amount ? _c('span', {
    staticClass: "amount monospace"
  }, [_vm._v(_vm._s(_vm.amount))]) : _vm._e(), _c('span', {
    staticClass: "symbol"
  }, [_c('router-link', {
    staticClass: "asset_link",
    attrs: {
      "to": "/asset/".concat(_vm.utxo.assetID)
    }
  }, [_vm._v(_vm._s(_vm.symbol))])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }